module.exports = __webpack_public_path__ + "img/calendar-19_fill.f6d6a6a3.svg";